import useTranslate from 'hooks/useTranslate';
import { useNavigate } from 'react-router-dom';
import styles from './NotFound.module.scss';

const NotFound = () => {
	const { translate } = useTranslate();
	const navigate = useNavigate();

	const handleBackClick = () => {
		navigate(-1);
	};

	return (
		<div className={styles.notFoundContainer}>
			<div className={styles.content}>
				<div className={styles.illustration}>
					{/* Use a friendly icon or emoji. Replace with SVG if available. */}
					<i className="ri-emotion-sad-line" />
				</div>
				<div className={styles.heading}>404 - {translate('Common.notFound')}</div>
				<div className={styles.subtext}>
					{translate('Common.thePageYouReLookingForDoesnTExist')}
				</div>
				<button className={styles.button} onClick={handleBackClick}>
					{translate('Common.back')}
				</button>
			</div>
		</div>
	);
};

export default NotFound;
